module.exports = __webpack_public_path__ + "static/wrkat-footerBanner-ee35630db9d175e37c9e4e17e01d8488.jpg";